import { Container, VStack } from '@chakra-ui/react';

import { DefaultLayout } from '../templates/DefaultLayout';
import { PageSendButton } from '../atom/button/PageSendButton';
import { useHome } from '../hooks/useHome';

export const Home = () => {
  const { handleTeikihoan, handleKaisen, handleHeisen, handleGasTen } =
    useHome();

  return (
    <DefaultLayout>
      <Container maxW="container.sm">
        <VStack mt={10}>
          <PageSendButton
            type="button"
            text="定期保安"
            onClick={handleTeikihoan}
            hidden={true}
          />
          <PageSendButton
            type="button"
            text="開栓"
            onClick={handleKaisen}
            hidden={true}
          />
          <PageSendButton
            type="button"
            text="閉栓"
            onClick={handleHeisen}
            hidden={true}
          />
          <PageSendButton
            type="button"
            text="ガス展イベント"
            onClick={handleGasTen}
            //hidden={true}
          />
        </VStack>
      </Container>
    </DefaultLayout>
  );
};
